import styled from "styled-components";

export const LogoutContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoutLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  color: gray;
  margin: 0 auto;
  max-width: 500px;
  text-align: center;

  & button {
    margin-top: 50px;
  }
  & img {
    width: 500px;
  }
`;
